<template>
  <div id="clientlist">
    <div @click="back" class="header">
      <i class="iconfont">&#xe604;</i>
    </div>
    <div class="clientlist_work">
        <div class="client_item border-bottom" v-for="item in clientList" :key="item.id" >
          <div class="client_item_left" @click="selectClient(item)">
            <div class="client_item_name">{{item.name}}</div>
            <div class="client_item_act">{{item.account}}</div>
          </div>
          <div class="client_item_right">
            <span @click="editInfo(item)" class="client_item_edit">
              <i class="iconfont">&#xe616;</i>
            </span>
            <span @click="deleteInfo(item)" class="client_item_delete">
              <i class="iconfont">&#xe78d;</i>
            </span>
          </div>
        </div>
    </div>
    <div class="client_add">
      <button @click="addClient">添加用户</button>
    </div>
  </div>
</template>

<script>
// import url from '@/common/common.js'
export default {
  name: 'ClientMess',
  data () {
    return {
      clientList: []
    }
  },
  methods: {
    /* 返回上一层 */
    back () {
      this.$router.push({
        path: '/transfer'
      })
    },
    /* 编辑用户信息 */
    editInfo (info) {
      this.$router.push({
        path: '/editclient',
        query: {
          clientInfo: info
        }
      })
    },
    /* 选择用户 */
    selectClient (info) {
      this.$router.push({
        path: '/transfer',
        query: {
          clientInfo: info
        }
      })
    },
    /* 添加用户 */
    addClient () {
      this.$router.push({
        path: '/addclient'
      })
    },
    /* 删除用户 */
    deleteInfo (item) {
      var r = confirm('确认删除')
      if (r === true) {
        this.deleteClientInfo(parseInt(item.id))
      }
    },
    /* 删除用户信息 */
    deleteClientInfo (id) {
      this.axios.get('/ApiLinkMan/DeleteLinkMan?id=' + id)
        .then(this.deleteClientInfoSucc)
        .catch(this.deleteClientInfoFail)
    },
    deleteClientInfoSucc (res) {
      res = res.data || {}
      if (res.errorInfo === '') {
        this.getListInfo()
      } else {
        alert(res.errorInfo)
      }
    },
    deleteClientInfoFail (err) {
      console.log(err)
      alert(err)
    },
    /* 获取用户列表 */
    getListInfo () {
      this.axios.get('/ApiLinkMan/GetList')
        .then(this.getListInfoSucc)
        .catch(this.getListInfoFail)
    },
    getListInfoSucc (res) {
      res = res.data || {}
      console.log('###获取用户列表####', res)
      if (res.errorInfo === '') {
        this.clientList = JSON.parse(res.data.linkManList)
      } else {
        alert(res.errorInfo)
      }
    },
    getListInfoFail (err) {
      console.log(err)
      alert('获取数据失败')
    }
  },
  mounted () {
    this.getListInfo()
  }
}
</script>

<style scoped>
#clientlist{min-height: 100%;}
.header{ display: flex; justify-content: space-between; align-items: center; padding: 10px 15px 5px;}
.header a{ text-decoration: none; color: #333;}
.header .iconfont{ font-size: 25px;}
.clientlist_work{padding:0 10px;border-top: 10px solid #f2f2f2;}
.client_item{display: flex;justify-content: space-between;padding: 10px 10px;}
.client_item_left{display: flex;justify-content: flex-start;align-items: center;flex-grow: 1;}
.client_item_left .client_item_name{min-width:160px;font-size: 16px;font-weight: 700;line-height: 22px;}
.client_item_left .client_item_act{margin-left: 10px;line-height: 22px;}
.client_add{margin: 30px 0;}
.client_add button{width: 80%; margin-right: auto;margin-left: auto;background-color: #ed2727;color: #fff;display: block;border: 0;height: 33px;border-radius: 3px;font-size: 14px}
.iconfont{font-size: 20px;}
.client_item_edit .iconfont{font-size: 20px;}
.client_item_delete{display: inline-block;margin-left: 6px;}
.client_item_delete .iconfont{font-size: 18px;}
</style>



// WEBPACK FOOTER //
// src/pages/clientlist/components/Mess.vue